/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './generated-subscription-schema';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './generated-subscription-schema';
export type SubscriptionUserNotificationSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type SubscriptionUserNotificationSubscription = {
  __typename: 'Subscription';
  userNotification: {
    __typename: 'UserNotification';
    notificationId: string;
    documentId: string;
    notificationType: Types.SubscriptionNotificationType;
    operation: Types.SubscriptionNotificationOperation;
    status: Types.SubscriptionNotificationStatus;
    title: string;
    message: string;
    payload: any;
    action: {
      __typename: 'NotificationAction';
      type: Types.SubscriptionNotificationActionType;
      target: string;
    };
  };
};

export type SubscriptionWorkflowCountsUpdateSubscriptionVariables = Exact<{
  input: Types.SubscriptionWorkflowCountsFilter;
}>;

export type SubscriptionWorkflowCountsUpdateSubscription = {
  __typename: 'Subscription';
  workflowCountsUpdate: Array<{
    __typename: 'WorkflowCounts';
    workflowType: Types.SubscriptionWorkflowType;
    labelCounts: Array<{
      __typename: 'LabelCount';
      label: string;
      count: number;
      highPriorityCount: number;
      description: string;
    }>;
  }>;
};

export type SubscriptionLedgerAccountUpdateSubscriptionVariables = Exact<{
  id: string;
}>;

export type SubscriptionLedgerAccountUpdateSubscription = {
  __typename: 'Subscription';
  ledgerAccountUpdate: {
    __typename: 'LedgerAccountUpdate';
    limit: number;
    balance: number;
    accountType: Types.SubscriptionAccountType;
    fortaLoanId: string;
    tenantId: string;
    originatorId: string;
  };
};

export const UserNotificationDocument = gql`
  subscription userNotification {
    userNotification {
      notificationId
      documentId
      notificationType
      operation
      status
      title
      message
      payload
      action {
        type
        target
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SubscriptionUserNotificationGQL extends Apollo.Subscription<
  SubscriptionUserNotificationSubscription,
  SubscriptionUserNotificationSubscriptionVariables
> {
  override document = UserNotificationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const WorkflowCountsUpdateDocument = gql`
  subscription workflowCountsUpdate($input: WorkflowCountsFilter!) {
    workflowCountsUpdate(input: $input) {
      workflowType
      labelCounts {
        label
        count
        highPriorityCount
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SubscriptionWorkflowCountsUpdateGQL extends Apollo.Subscription<
  SubscriptionWorkflowCountsUpdateSubscription,
  SubscriptionWorkflowCountsUpdateSubscriptionVariables
> {
  override document = WorkflowCountsUpdateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LedgerAccountUpdateDocument = gql`
  subscription LedgerAccountUpdate($id: UUID!) {
    ledgerAccountUpdate(id: $id) {
      limit
      balance
      accountType
      fortaLoanId
      tenantId
      originatorId: subTenantId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SubscriptionLedgerAccountUpdateGQL extends Apollo.Subscription<
  SubscriptionLedgerAccountUpdateSubscription,
  SubscriptionLedgerAccountUpdateSubscriptionVariables
> {
  override document = LedgerAccountUpdateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
